import { useEffect, useState } from "react";
import { getApi } from "../../services/api/globalApi";
import { AiTwotoneShop } from "react-icons/ai";

export default function TotalPendingVendore() {
  const [count, setCount] = useState(0);

  const getAllOrderPendingCount = async () => {
    try {
      const getData = await getApi({
        path: "admin/reports/totalProccessingOrdersCount",
      });
      setCount(getData.data.result);
    } catch (error) {
      console.error("Error fetching pending order count:", error);
    }
  };

  useEffect(() => {
    getAllOrderPendingCount();

    const interval = setInterval(() => {
      getAllOrderPendingCount();
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative flex h-10 w-10 items-center justify-center rounded-xl border border-slate-200 bg-slate-50 text-slate-600 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200" title="غرفه‌های در انتظار">
      <div className="flex items-center justify-center">
        <AiTwotoneShop size={19} />
        <span className="absolute -bottom-1 -left-1 flex h-5 min-w-5 items-center justify-center rounded-full border-2 border-white bg-blue-600 px-0.5 text-[10px] font-semibold text-white dark:border-slate-900">
          {0}
        </span>
      </div>
    </div>
  );
}
